import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';
import type { Reservation } from '@/api/reservations';

type Variables = {
  id: number;
  startingMileage?: number;
  endingMileage?: number;
  notes?: string;
};
export type UpdateLocationResponse = {
  location: Reservation;
};

export const useUpdateReservation = createMutation<
  UpdateLocationResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/internal/partners/reservations/${variables.id}`,
      method: 'PUT',
      data: {
        starting_mileage: variables.startingMileage,
        ending_mileage: variables.endingMileage,
        host_notes: variables.notes,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.error);
      }),
});
